// extracted by mini-css-extract-plugin
export var grid = "_1s-0";
export var span1 = "_1s-2";
export var span10 = "_1s-b";
export var span10L = "_1s-z";
export var span10M = "_1s-n";
export var span10Xl = "_1s-1b";
export var span11 = "_1s-c";
export var span11L = "_1s-10";
export var span11M = "_1s-o";
export var span11Xl = "_1s-1c";
export var span12 = "_1s-d";
export var span12L = "_1s-11";
export var span12M = "_1s-p";
export var span12Xl = "_1s-1d";
export var span1L = "_1s-q";
export var span1M = "_1s-e";
export var span1Xl = "_1s-12";
export var span2 = "_1s-3";
export var span2L = "_1s-r";
export var span2M = "_1s-f";
export var span2Xl = "_1s-13";
export var span3 = "_1s-4";
export var span3L = "_1s-s";
export var span3M = "_1s-g";
export var span3Xl = "_1s-14";
export var span4 = "_1s-5";
export var span4L = "_1s-t";
export var span4M = "_1s-h";
export var span4Xl = "_1s-15";
export var span5 = "_1s-6";
export var span5L = "_1s-u";
export var span5M = "_1s-i";
export var span5Xl = "_1s-16";
export var span6 = "_1s-7";
export var span6L = "_1s-v";
export var span6M = "_1s-j";
export var span6Xl = "_1s-17";
export var span7 = "_1s-8";
export var span7L = "_1s-w";
export var span7M = "_1s-k";
export var span7Xl = "_1s-18";
export var span8 = "_1s-9";
export var span8L = "_1s-x";
export var span8M = "_1s-l";
export var span8Xl = "_1s-19";
export var span9 = "_1s-a";
export var span9L = "_1s-y";
export var span9M = "_1s-m";
export var span9Xl = "_1s-1a";
export var stretch = "_1s-1";